/**
 * Renders document number with optional amendment suffix.
 * If the API already merged both (e.g. "234/1"), returns the value unchanged.
 */
export function formatFileNumberWithSubNumber(
  number?: number | string | null,
  subNumber?: number | null
): string {
  const hasSub = subNumber != null && subNumber > 0;
  if (number == null || number === "") {
    return "";
  }
  const base = String(number);
  if (base.includes("/")) {
    return base;
  }
  if (hasSub) {
    return `${base}/${subNumber}`;
  }
  return base;
}
